import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { Loader2 } from 'lucide-react';

export function CalendlyCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const processCallback = async () => {
      try {
        // Get the authorization code from URL parameters
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
          console.error('Calendly OAuth error:', error);
          toast({
            title: "Authorization Failed",
            description: "There was an error connecting to Calendly. Please try again.",
            variant: "destructive",
          });
          navigate('/dashboard');
          return;
        }

        if (!code) {
          console.error('No authorization code received');
          toast({
            title: "Authorization Failed",
            description: "No authorization code received from Calendly.",
            variant: "destructive",
          });
          navigate('/dashboard');
          return;
        }

        console.log('Calendly OAuth successful', { code, state });
        
        // Here you would typically exchange the code for an access token
        // and store the Calendly integration details
        
        toast({
          title: "Successfully Connected",
          description: "Your Calendly account has been connected successfully!",
          className: "bg-card border-none text-foreground",
        });

        // Redirect to dashboard or integration settings
        navigate('/dashboard');
        
      } catch (error) {
        console.error('Error processing Calendly callback:', error);
        toast({
          title: "Connection Error",
          description: "There was an error processing the Calendly connection.",
          variant: "destructive",
        });
        navigate('/dashboard');
      } finally {
        setIsProcessing(false);
      }
    };

    processCallback();
  }, [searchParams, navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-foreground">
            Connecting to Calendly
          </h2>
          <p className="text-muted-foreground">
            {isProcessing ? 'Processing your authorization...' : 'Redirecting...'}
          </p>
        </div>
      </div>
    </div>
  );
}